








































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TForm } from '@/plugins/podolib/lib/types';
import { Severity } from '@sentry/types';
import { Document } from '@/plugins/podolib/services/doctor';

type TFields = {
  consented: {
    [key in Document]: boolean;
  };
};

@Component
export default class TermsAndConditions extends Vue {
  form: TForm<TFields> = {
    fields: {
      consented: {
        TOU: false,
        DPA: false,
      },
    },
    pending: false,
    error: null,
    success: false,
  };

  selectedStepIndex: number = 1;

  get lang() {
    return this.$pdc.doctor!.current.config.lang;
  }

  get documents() {
    return {
      TOU: this.$pdc.helper!.fromCdn('other', `legal/TOU/20191105_TOU_PodoSmart_${this.lang}.pdf`),
      DPA: this.$pdc.helper!.fromCdn('other', `legal/DPA/20191105_DPA_DS_ProX_${this.lang}.pdf`),
    };
  }

  get dialog(): boolean {
    return !this.$store.getters['pdc/doctor/termsAndConditionsConsented'];
  }

  @Watch('dialog')
  onDialogChanged(state: boolean) {
    if (state) {
      // Populate form
      this.form.fields.consented.TOU = false;
      this.form.fields.consented.DPA = false;
      // Reset flags
      this.form.success = false;
      this.form.error = null;
    }
  }

  @Watch('form.fields', { deep: true })
  onFormFieldsDeeplyChanged(newFormFields: TFields, oldFormFields: TFields) {
    // To avoid flash css switch
    if (!this.dialog) return;
    // Reset flags
    this.form.success = false;
    this.form.error = null;
  }

  /*@Watch('form.fields.consented.TOU')
  onFormFieldsConsentedTOUChanged(n: TFields['consented']['TOU'], o: TFields['consented']['TOU']) {
    if (n !== o) {
      // Analytics
      this.$pdc.analytics?.actions.trackSuccess('User CheckTOS', {
        document: Document.TOU,
        checked: n
      });
    }
  }*/

  /*@Watch('form.fields.consented.DPA')
  onFormFieldsConsentedDPAChanged(n: TFields['consented']['DPA'], o: TFields['consented']['DPA']) {
    if (n !== o) {
      // Analytics
      this.$pdc.analytics?.actions.trackSuccess('User CheckTOS', {
        document: Document.DPA,
        checked: n
      });
    }
  }*/

  async save() {
    try {
      // @ts-ignore
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      // Reset flags
      this.form.success = false;
      this.form.error = null;
      // Set 'pending' flag
      this.form.pending = true;
      // Try to patch the station ...
      await this.$pdc.repository!.patchRessource({
        ressource: 'doctors',
        // identifier: this.$pdc.doctor!.current._id,
        params: {
          _id: this.$pdc.doctor!.current._id,
        },
        data: {
          termsAndConditions: {
            consented: true,
          },
        },
      });
      // Analytics
      /*this.$pdc.analytics?.actions.trackSuccess('User AcceptTOS', {
        documents: this.form.fields.consented
      });*/
      this.form.success = true;
    } catch (e) {
      // Analytics
      /*this.$pdc.analytics?.actions.trackFailure('User AcceptTOS', e, {
        documents: this.form.fields.consented
      });*/
      // TODO : add error display

      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Critical);
    } finally {
      // Reset 'pending' flag
      this.form.pending = false;
    }
  }
}
